import {connect} from 'react-redux'
import {setAmazonLinks} from '../redux/actions'

const AmazonCheckLink = (props) =>
  (<div class="amazon-check-link">
    <iframe onLoad={()=> props.setAmazonLinks(true)} style={{"width":"120px","height":"240px"}} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src={"//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=fitted07-20&marketplace=amazon&amp;region=US&placement=B07P14QW3X&asins=B07P14QW3X&linkId=1a470b37d28a2853a544eeb636bd5aed&show_border=false&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff"}>
    </iframe>
  </div>)


  const mapStateToProps = (state) => ({
  })
  const actionsCreators = {
    setAmazonLinks:setAmazonLinks,
  }
  export default connect(mapStateToProps, actionsCreators)(AmazonCheckLink)
